import React from 'react';
import { useNavigate } from 'react-router-dom';
import { actionIcons } from '../../../../../configs/Icons';
import { useAuth } from '../../../../Contexts/AuthProvider';
import { UserCardV2 } from '../../../../features/User/UserCard';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function LogoutButton({ onclick, disabled }) {
    return (
        <button
            type="button"
            onClick={onclick}
            disabled={disabled}
            className={`group ${disabled ? 'grayscale-[100%] pointer-events-none' : ''}`}
            aria-label="Loading..."
        >
            <img src={actionIcons.accessWL} alt="" className="block group-hover:hidden" />
            <img src={actionIcons.accessWF} alt="" className="hidden group-hover:block" />
        </button>
    );
}

function TableRow({ item, handleLogoutClick }) {
    const { authInfo } = useAuth();
    const navigate = useNavigate();

    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td className="!pl-5">
                <span>{item?.id}</span>
            </td>
            <td aria-label="Loading...">
                <UserCardV2
                    icon={item?.photoUrl}
                    title={`${item?.firstName || ''} ${item?.lastName || ''}`}
                    subTitle={item?.primaryEmail}
                />
            </td>
            <td>
                <span>{item?.userName || '-----'}</span>
            </td>
            <td
                onClick={() => navigate(mkRelativeUrl(`/customers/${item?.id}/info`))}
                className="cursor-pointer hover:underline"
            >
                <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium group-hover:text-secondary">
                    {item?.organization || '-----'}
                </span>
            </td>
            <td>
                <span>{item?.primaryPhone || '------'}</span>
            </td>
            <td>
                <span className={item?.timeCreated ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(item?.timeCreated) || '--'}
                </span>
            </td>

            <td className="text-center !pr-5" aria-label="Loading...">
                <div className="flex flex-row w-full justify-end relative">
                    <span>
                        <LogoutButton
                            onclick={(ev) => handleLogoutClick(ev, item?.id)}
                            disabled={authInfo?.data?.id === item?.id}
                        />
                    </span>
                </div>
            </td>
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col" className="!w-14">
                    <span className="uppercase">Id</span>
                </th>
                <th scope="col">
                    <span>Name & Email</span>
                </th>
                <th scope="col">
                    <span>Username</span>
                </th>
                <th scope="col">
                    <span>Organization</span>
                </th>

                <th scope="col" className="w-32 text-center">
                    <span>Phone Number</span>
                </th>

                <th scope="col" className="w-30 text-center">
                    <span>Created</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function PageTable({ data, handleLogoutClick }) {
    return (
        <div className="auth_manage_page_table mb-52 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    {data && data?.length === 0 && (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Users Found!
                            </td>
                        </tr>
                    )}
                    {data?.map((item) => (
                        <TableRow
                            key={item?.id}
                            item={item}
                            handleLogoutClick={handleLogoutClick}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default PageTable;
